import { IH2OTheme } from '@h2oai/ui-kit';

export const mlopsTopStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: '1rem',
};

export const mlopsSummaryTopStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '4rem',
};

export const menuItemStyle = {
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
  gap: '1rem',
};

export const comboBoxStyle = {
  width: 400,
};

export const startDatePickerStyle = {
  width: 200,
};

export const endDatePickerStyle = {
  width: 200,
};

export const summaryDatePickerAreaStyle = {};

export const summaryDatePickerStyle = {
  width: 200,
};

export const GaugeMetricStatContainerStyle = (theme: IH2OTheme) => ({
  marginTop: '1rem',
  backgroundColor: theme.palette?.gray200,
});
